import AccountListView from '@/views/Accounts/AccountListView/AccountListView.vue'
import AccountCreateView from '@/views/Accounts/AccountCreateView/AccountCreateView.vue'
import AccountDetailView from '@/views/Accounts/AccountDetailView/AccountDetailView.vue'

export default [
  {
    path: '/merchants/:merchantID/accounts',
    component: AccountListView,
    name: 'AccountList'
  },
  {
    path: '/merchants/:merchantID/accounts/:accountID',
    component: AccountDetailView,
    name: 'AccountDetail'
  },
  {
    path: '/merchants/:merchantID/accounts/create',
    component: AccountCreateView,
    name: 'AccountCreate'
  }
]
